import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';
    
@Injectable()
export class UserService {
    

  constructor(
              private http: HttpClient,
              private global: GlobalDataService
             ) { }

    getUser() {
        return this.http.get(this.global.httpUrl+"users")
    }

    getUserById(id: any){
         return this.http.get(this.global.httpUrl+"users/"+id);
    }
    getUserByFilter(filter: any[]){
        let url = "";
        for (var item of filter) {
            url += item.name + "=" + item.value + "&";
        }
        url = url.substring(0,url.length-1);
        
        return this.http.get(this.global.httpUrl + "users?" + url);
    }

    postData(jsData: any){
        return this.http.post(this.global.httpUrl+"users", jsData); 
        }


    putData(jsData: any, id: any){
        return this.http.put(this.global.httpUrl+"users/"+id, jsData); 
    }
}




// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/users/user.service.ts